import React, {Component} from "react";
import PropTypes from 'prop-types';
import {Row, Col, Progress, Card, Alert, CardHeader, CardTitle, FormGroup, Label, Form, Input, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, Button, ButtonDropdown, Table, Badge,  Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem, FormText, InputGroup,  Nav, NavItem, NavLink, TabContent, TabPane} from 'reactstrap';
import {Bar, Line} from "react-chartjs-2";
import classNames from 'classnames';
import {mapToCssModules} from 'reactstrap/lib/utils';
import classnames from "classnames";
import { RIEToggle, RIEInput, RIETextArea, RIENumber, RIETags, RIESelect } from 'riek'
import _ from 'lodash'
import Select from 'react-select';
import 'react-select/dist/react-select.min.css';
import Popover from 'react-awesome-popover';
import "react-awesome-popover/dest/react-awesome-popover.css";
import TagBindingStructure from '../Support/TagBindingStructure';
const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';



const propTypes = {
    header: PropTypes.string,
    mainText: PropTypes.string,
    icon: PropTypes.string,
    color: PropTypes.string,
    variant: PropTypes.string,
    footer: PropTypes.bool,
    link: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    cssModule: PropTypes.object,
    systemVoltage: PropTypes.number,
    developer: PropTypes.bool,
    valuechangeinput: PropTypes.func,
};
const defaultProps = {
    header: 'Undefined',
    mainText: 'Undefined',
    icon: "fa fa-arrows-h",
    color: 'gray-100',
    variant: "0",
    link: "#"
};

class ComponentAts extends Component {

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            activeTab: '1',
            selectTagModal: false
        };
        this.valueChanged = this.valueChanged.bind(this);
        this.toggleSelectTagModal = this.toggleSelectTagModal.bind(this);
        this.saveChangesSelectTag = this.saveChangesSelectTag.bind(this);

    }


    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }
    valueChanged(e) {
        let keyName = Object.keys(e)[0];
        this.props.valuechangeinput(keyName,e[keyName]);
    }
    toggleSelectTagModal() {
        this.setState({
            selectTagModal: !this.state.selectTagModal
        });
    }
    saveChangesSelectTag(value) {
        this.setState({
            addAlarmTag: value.value
        });
    }

    convertBits(word = 0, bit = 0){
        let arrayReturned = [];
        for (let i = 0; i < 15; i++)
            arrayReturned[i] = (word >> i) & 1;
        return arrayReturned[bit] === 1;
    }
    round(value, decimals) {
        return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
    }
    checkTagBit(schema, returnText = true) {
        //console.log('test -> ' + this.convertBits(this.props.iotData[schema.tag.id],schema.tagBit.id));
        //console.log('schema.tag.id: ' + schema.tag.id);
        //console.log('here:' + this.props.iotData[schema.tag.id]);
        return schema.tagBit.text === "noBit" ? this.round(parseFloat(this.props.iotData[schema.tag.id] || 0 ) * parseFloat(schema.tagScale || 1) + parseFloat(schema.tagOffset || 0),parseInt(schema.tagDecimals)): returnText ? this.convertBits(this.props.iotData[schema.tag.id],schema.tagBit.id) ? "On" : "Off" : this.convertBits(this.props.iotData[schema.tag.id],schema.tagBit.id);
    }


    render() {
        const {className, cssModule, header, mainText, icon, color, footer, link, children, variant, ...attributes} = this.props;

        const padding = (variant === '0' ? {card: "p-3", icon: "p-3", lead: "mt-2"} : ( variant === "1" ? {
            card: "p-0", icon: "p-4", lead: "pt-3" } : {card: "p-0", icon: "p-4 px-5", lead: "pt-3"}));

        const card = {style: "card-body clearfix", color: color, icon: icon, classes: ""};
        card.classes = mapToCssModules(classNames(className, card.style, padding.card), cssModule);

        const lead = {style: "h5 mb-0", color: color, classes: ""};
        lead.classes = classNames(lead.style, 'text-' + card.color, padding.lead);

        const blockIcon = function (icon) {
            const classes = classNames(icon, 'bg-' + card.color, padding.icon, "font-2xl mr-3 float-left");
            return (<i className={ classes }></i>);
        };

        let componentData = this.props.componentdata;

        return (
            <Card className={this.props.developer ? "mt-1" : ""}>
                <CardBody className={ card.classes }>
                    { blockIcon(card.icon) }
                    <div className={ lead.classes }>
                        <RIEInput
                            value={componentData.name}
                            change={this.valueChanged}
                            propName='name'
                            isDisabled={!this.props.developer}
                        />
                    </div>
                    <div className="text-muted text-uppercase font-weight-bold font-xs">
                        <RIEInput
                            value={componentData.desc}
                            change={this.valueChanged}
                            propName='desc'
                            isDisabled={!this.props.developer}
                        />
                    </div>
                    <hr />
                    {this.props.developer &&
                    ( <Row className="pb-3">
                        <Col sm="12">
                            <RIEToggle
                                className={`btn btn-block btn-sm ${componentData.position.visibility ? "btn-developer" : "btn-secondary"}`}
                                value={componentData.position.visibility}
                                change={this.valueChanged}
                                textTrue="Hide Position"
                                textFalse="Show Position"
                                propName='position.visibility'
                                isDisabled={false}
                            />
                        </Col>
                    </Row> )}
                    {componentData.position.visibility ?
                        <Row>
                            <Col xs="5" sm="5" lg="5">
                                <div className="text-muted text-uppercase font-weight-normal font-xs">
                                    <RIEInput
                                        value={componentData.position.name}
                                        change={this.valueChanged}
                                        propName='position.name'
                                        isDisabled={!this.props.developer}
                                    />
                                </div>
                            </Col>
                            <Col xs="5" sm="4" lg="5">
                                <div>{this.checkTagBit(componentData.position,false)?
                                    <Badge color={componentData.position.boolConfig.trueColor.id}>{componentData.position.boolConfig.trueMsg}</Badge> :
                                    <Badge color={componentData.position.boolConfig.falseColor.id}>{componentData.position.boolConfig.falseMsg}</Badge>}</div>
                            </Col>
                            {this.props.developer && (
                                <Col xs="1" sm="1" lg="1">
                                    <TagBindingStructure
                                        valueTag={componentData.position.tag}
                                        optionsTag={this.props.iodb}
                                        propNameTag="position.tag"
                                        valueBit={componentData.position.tagBit}
                                        optionsBit={this.props.tagBits}
                                        propNameBit="position.tagBit"
                                        change={this.valueChanged}
                                        componentIsBeingEdited={(status) => this.props.componentIsBeingEdited(status)}
                                        isBool={true}
                                        valueBoolConfig={componentData.position.boolConfig}
                                        propNameBoolConfig="position.boolConfig"
                                    />
                                </Col> )}
                        </Row>
                        : ""
                    }
                </CardBody>
            </Card>
        )
    }
}

ComponentAts.propTypes = propTypes;
ComponentAts.defaultProps = defaultProps;


export default ComponentAts;


// WEBPACK FOOTER //
// ./src/views/site/Developer/DeveloperOverviewRender/Components/ComponentAts.js